import { useOnMount } from './useOnMount';

export const useInterval = (action: () => void, timeoutInMilliseconds: number) =>
  useOnMount(() => {
    const interval = window.setInterval(action, timeoutInMilliseconds);
    return () => window.clearInterval(interval);
  });
